/** Busca de cliente pelo nome ou telefone (épico 5.1). */
import type { Client } from '../schemas/entities';

function fold(s: string): string {
  return s
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();
}

export function matchClient(client: Pick<Client, 'name' | 'whatsapp'>, query: string): boolean {
  const q = fold(query);
  if (!q) return true;
  const digits = query.replace(/\D/g, '');
  if (digits.length >= 3 && client.whatsapp?.includes(digits)) return true;
  const name = fold(client.name);
  return q.split(/\s+/).every((part) => name.includes(part));
}
